<template class="d-flex">
  <v-container>
    <v-row class=" container text-center flex-column margin-center">
      <v-col class="mb-4">
          <v-img
            :src="require('../assets/visa card bg-iskoseno.png')"
            class="my-3 pa-2 poklon"
            contain
          />
        <h1 class="my-3 mt-0 sheadline text-left font-weight-bold mb-3">
          Uspešno ste se prijavili za poklon karticu
        </h1>
        <p class="subheading text-left font-weight-medium pt-3 pb-3">
         Hvala vam što ste se prijavili za poklon karticu. Naš tim će obraditi vaš zahtev i poslati vam karticu na adresu koju ste koristili prilikom prijave.
        </p>
      </v-col>
      <v-col>
        <div class="text-center md-5">
          <router-link to="/" style="text-decoration:none;">
            <v-btn width="-webkit-fill-available"   height="50" rounded color="primary" dark>Vratite se nazad</v-btn>
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
  name: 'Gift',
  data() {
    return {

      }
    },
    methods:{

    },
    computed: {

    },


}

</script>


<style>
 .poklon {
   width: 50%!important;
   margin: 0 auto;
 }
 @media only screen and (max-device-width: 768px) {
      .poklon {
          width: 100%!important;
          margin: 0 auto;
        }
}
</style>